export default __webpack_public_path__ + "static/media/home1.832857cd.jpg";